import { toast } from 'react-toastify';
import { api } from '../../../api';
import { HOST_NAME, socketProtocol } from '../../../api/baseQuery';
import store from '../../../store';
import { booksApi } from '../../books/api/booksApi';
import { ChatConnection, ChatMessageTypes } from './types';

export let chatSocket: WebSocket;

export const getChatSocket = (token: string) => {
  const url = `${socketProtocol}${HOST_NAME}/chat/?token=${token}`;
  return new WebSocket(url);
};

export const sendToWs = (data: Record<string, string>) => {
  if (!chatSocket) return;
  if (chatSocket.readyState !== WebSocket.OPEN) return;

  chatSocket.send(JSON.stringify(data));
};

export const chatInitialState: ChatConnection = {
  conversation: null,
  messages: [],
  conversations: [],
  isTyping: false,
  isConnected: false,
  nextPage: null,
  totalUnread: 0
};

export const chatApi = api
  .enhanceEndpoints({
    addTagTypes: ['Chat']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getChatConnection: build.query<ChatConnection, void>({
        queryFn: () => ({
          data: chatInitialState
        }),

        async onCacheEntryAdded(
          _arg,
          { cacheEntryRemoved, cacheDataLoaded, updateCachedData, dispatch }
        ) {
          const token = store.getState().auth.token;
          if (!token) return;
          const socket = getChatSocket(token);
          chatSocket = socket;

          const onOpen = () => {
            console.info('%cCONNECTION IS OPENED', 'color: green');
            updateCachedData((draft) => {
              draft.isConnected = true;
            });
          };
          const onClose = () => {
            console.info('%cCONNECTION CLOSE', 'color: salmon');
            updateCachedData((draft) => {
              draft.isConnected = false;
            });
          };
          const onError = (event: any) => {
            console.info('Error', event);
            updateCachedData((draft) => {
              draft.isConnected = false;
            });
          };
          const onMessage = (event: any) => {
            const data = JSON.parse(event.data);

            switch (data.msg_type) {
              case ChatMessageTypes.GetDialogs:
                const { dialogs } = data;
                updateCachedData((draft) => {
                  draft.conversations = dialogs;
                });
                break;

              case ChatMessageTypes.GetMessagesFromDialog:
                const { messages, dialog, next } = data;
                updateCachedData((draft) => {
                  draft.messages = messages;
                  draft.conversation = dialog;
                  draft.nextPage = next;
                });
                break;

              case ChatMessageTypes.StartChat:
                const { conversation_id } = data;
                console.log('st', conversation_id);
                window.location.href = `/chat/${conversation_id}`;
                break;

              case ChatMessageTypes.TextMessage:
                const { message: userMessage, recipient, dialog_id } = data;
                updateCachedData((draft) => {
                  if (draft.conversation?.id === Number(dialog_id)) {
                    draft.messages.unshift(userMessage);
                  }

                  const dialog = draft.conversations?.find(
                    (dialog) => dialog.id === Number(dialog_id)
                  );

                  if (dialog) {
                    dialog.last_message = userMessage;
                  }
                });
                break;

              case ChatMessageTypes.IsTyping:
                const { user_pk: typingUserPk } = data;
                updateCachedData((draft) => {
                  if (draft.conversation?.recipient.id === Number(typingUserPk)) {
                    draft.isTyping = true;
                  } else {
                    // const dialog = draft.conversations.find(
                    //   (dialog) =>
                    //     dialog.user1 === Number(typingUserPk) ||
                    //     dialog.user2 === Number(typingUserPk)
                    // );
                    // if (dialog) {
                    //   dialog.isTyping = true;
                    // }
                  }
                });
                break;

              case ChatMessageTypes.TypingStopped:
                const { user_pk: stoppedUserPk } = data;
                updateCachedData((draft) => {
                  if (draft.conversation?.recipient.id === Number(stoppedUserPk)) {
                    draft.isTyping = false;
                  } else {
                    // const dialog = draft.conversations.find(
                    //   (dialog) =>
                    //     dialog.user1 === Number(typingUserPk) ||
                    //     dialog.user2 === Number(typingUserPk)
                    // );
                    // if (dialog) {
                    //   dialog.isTyping = true;
                    // }
                  }
                });
                break;

              case ChatMessageTypes.NewUnreadCount:
                const newUnread = data.unread_count;
                const dialogId = data.dialog_id;

                updateCachedData((draft) => {
                  const dialog = draft.conversations.find(
                    (dialog) => dialog.id === Number(dialogId)
                  );
                  if (dialog) {
                    dialog.unread_messages = newUnread;
                  }
                });

                break;

              case ChatMessageTypes.TotalUnreadCount:
                const totalUnread = data.total_unread_count;
                updateCachedData((draft) => {
                  draft.totalUnread = totalUnread;
                });
                break;

              case ChatMessageTypes.WentOnline:
                const { user_pk } = data;
                updateCachedData((draft) => {
                  const dialog = draft.conversations.find(
                    (dialog) => dialog.user1 === Number(user_pk) || dialog.user2 === Number(user_pk)
                  );
                  if (dialog) {
                    dialog.recipient.is_online = true;
                  }
                });
                break;

              case ChatMessageTypes.WentOffline:
                const { user_pk: offlineUserPk } = data;
                updateCachedData((draft) => {
                  const dialog = draft.conversations.find(
                    (dialog) =>
                      dialog.user1 === Number(offlineUserPk) ||
                      dialog.user2 === Number(offlineUserPk)
                  );
                  if (dialog) {
                    dialog.recipient.is_online = false;
                  }
                });
                break;

              case ChatMessageTypes.BookDetailsReady:
                const { book_details } = data;
                console.log('Book details ready', book_details);
                dispatch(
                  booksApi.util.updateQueryData('getDraftBooks', undefined, (draftBooks) => {
                    const book_index = draftBooks.results.findIndex(
                      (book) => book.id === book_details.id
                    );

                    if (book_index !== -1) {
                      draftBooks.results[book_index] = book_details;
                      toast(`${book_details.title} is ready!`, { type: 'success' });
                    }
                  })
                );
                break;

              default:
                console.log('Default');
                break;
            }
          };

          try {
            await cacheDataLoaded;
            socket.addEventListener('close', onClose);
            socket.addEventListener('error', onError);
            socket.addEventListener('message', onMessage);
            socket.addEventListener('open', onOpen);
          } catch (error) {
            console.warn('Error occurred', error);
          }
          await cacheEntryRemoved;
          socket.close();
        }
      })
    })
  });

export const { useGetChatConnectionQuery } = chatApi;
